// extracted by mini-css-extract-plugin
export default {"frags_columns":"FragList_frags_columns__LzYeN"};